import React from 'react';
import { Root } from '@radix-ui/react-accordion';
import classNames from 'classnames';
import favouriteMenuStyle from './components/liveNavFavouriteMenuItem/LiveNavFavouriteMenuItem.module.scss';
import styles from 'features/sport/components/sportNav/SportNav.module.scss';
import stylesAccordionList from 'features/sport/components/sportNav/sportNavAccordionList/SportNavAccordionList.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { isTruthy } from 'utility/functions';
import { LiveVideoStreamingContainer } from '../liveVideoStreamingContainer';
import { LiveDisciplinaMenuItem } from './components/liveDisciplinaMenuItem/LiveDisciplinaMenuItem';
import { LiveNavFavouriteMenuItem } from './components/liveNavFavouriteMenuItem/LiveNavFavouriteMenuItem';
import { useExpandedItems, useMenu } from './hooks';
import { LIVE_STREAMING_ID, VideoStreamingMode } from '../liveVideoStreaming';
import { useSelector } from 'react-redux';
import { selectIsStreamingOpen } from 'features/settings/selectors';

export type LiveNavProps = {
  className?: string;
  hasStreaming?: boolean;
};

export const LiveNav: React.FC<LiveNavProps> = ({ className, hasStreaming }) => {
  const { ts, discipline } = useMenu({ isTop: false, isLive: true });
  const expandedItems = useExpandedItems();
  const sidebarHeaderLabel = useGetLabelByKey('sidebar-header');
  const isStreamingOpen = useSelector(selectIsStreamingOpen);

  const renderDiscipline = (): JSX.Element => {
    if (isTruthy(discipline?.length)) {
      return (
        <React.Fragment key={'sidebar'}>
          {discipline
            .filter((disciplina) => disciplina.id !== '-1')
            .filter((disciplina) => !disciplina.isVirtual)
            .map((disciplina) => (
              <LiveDisciplinaMenuItem {...disciplina} key={`disciplina-${disciplina.id}-${ts}`} />
            ))}
        </React.Fragment>
      );
    }

    return <React.Fragment key={'sidebar'} />;
  };

  return (
    <aside className={styles.sidebar}>
      <div id={`${VideoStreamingMode.minimal}-${LIVE_STREAMING_ID}`} />
      {hasStreaming && isStreamingOpen && <LiveVideoStreamingContainer />}

      <div className={classNames(styles.wrapper, className)}>
        <div className={favouriteMenuStyle.label}>{sidebarHeaderLabel}</div>
        <Root type="multiple" className={stylesAccordionList.container} defaultValue={expandedItems}>
          <LiveNavFavouriteMenuItem />
          {renderDiscipline()}
        </Root>
      </div>
    </aside>
  );
};
